import React from "react";
import { useState,useEffect } from "react";
import { Link } from "react-router-dom";

//SimpleBar
import SimpleBar from "simplebar-react";


import { Card, CardBody, CardTitle, Col } from "reactstrap";



const Notifications = (props) => {

  const store = props.store;
  const[NotificationsData,setNotificationsdata] = useState([])
  const[loaded,setLoaded]=useState(false)


  useEffect(()=>{
    const fetchData=async()=>{
      const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getOrdersbycustomers?store=${store}`);
      const data = await res.json();
      setNotificationsdata(data);
      setLoaded(true);
    }

    if(store){
      fetchData();
    }

  },[store])


  return (
    <React.Fragment>
      <Col lg={4}>
        <Card>
          <CardBody>
            <CardTitle>Orders by customers</CardTitle>
            {loaded &&
              <div className="pe-3">
              <SimpleBar style={{ maxHeight: "287px" }}>
                {NotificationsData.map((item, key) => (
                  <Link key={key} to="#" className="text-body d-block" style={{backgroundColor:'#eae9e9',marginTop:'2%'}}>
                    <div className="d-flex py-3">
                      <div className="flex-shrink-0 me-3 align-self-center">
                        {item.src ? (
                          <img
                            className="rounded-circle avatar-xs"
                            alt=""
                            src={item.src}
                          />
                        ) : (
                          <div className="avatar-xs">
                            <span className="avatar-title bg-soft-primary rounded-circle text-primary">
                              <i className={item.icon}></i>
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="flex-grow-1 overflow-hidden">
                        <h5 className="font-size-14 mb-1">{item.name}</h5>
                        <p className="text-truncate mb-0">Number of orders: {item.descr}</p>
                      </div>
                      {/* <div className="flex-shrink-0 font-size-13">
                        {item.time}
                      </div> */}
                    </div>
                  </Link>
                ))}
              </SimpleBar>
            </div>
            
            }
            {!loaded &&
            <p>Fetching data...</p>
            }
           
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};
export default Notifications;
